var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"selected-export-options-in-export-boxes"},[_c('i',{class:_vm.getOptionNameIcon()}),_vm._v(" "+_vm._s(this.$t(`label.${this.optionName}`))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }